import React from 'react';
import { useBackendStatus } from '../hooks/useBackendStatus';

const OfflineBanner: React.FC = () => {
  const { isBackendOnline, retryConnection, lastCheck } = useBackendStatus();

  if (isBackendOnline) {
    return null;
  }

  const formatLastCheck = (): string => {
    const now = Date.now();
    const diff = now - lastCheck;
    const minutes = Math.floor(diff / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    if (minutes > 0) {
      return `${minutes}m ${seconds}s`;
    }
    return `${seconds}s`;
  };

  return (
    <div className="bg-yellow-500 text-white px-4 py-2 flex items-center justify-between">
      <div className="flex items-center space-x-2">
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
            clipRule="evenodd"
          />
        </svg>
        <span className="font-medium">
          Backend Offline - Servicios no disponibles
        </span>
        <span className="text-sm opacity-75">
          (Última verificación: {formatLastCheck()} atrás)
        </span>
      </div>
      <button
        onClick={retryConnection}
        className="bg-yellow-600 hover:bg-yellow-700 px-3 py-1 rounded text-sm font-medium transition-colors"
      >
        Reintentar
      </button>
    </div>
  );
};

export default OfflineBanner;
